import { Space, Typography } from "antd";
import ReactQuill from "react-quill-new";
import { motion } from "framer-motion";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export const EssayOption = () => {
  const [value, setValue] = useState('<p><br></p>');
  const { t } = useTranslation();

  const handleChange = (text: string) => {
    setValue(text);
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 1 }}
    >
      <Space direction="vertical" style={{ display: "flex" }}>
        <Typography.Text strong>{t("forms.questions.inputPlaceholder")}</Typography.Text>
        <ReactQuill theme="snow" value={value} onChange={handleChange}/>
      </Space>
    </motion.div>
  );
};
